// Libraries
import { Stack, SvgIcon } from "@mui/material";

// Components
import PageLayer from "@/Layouts/views/PageLayer";
import PayrollMappingLayer from "@/Settings/components/PayrollMapping/PayrollMappingLayer";

// Icons
import { ReactComponent as Icon } from "@/assets/icons/header/settings/PayItemsIcon.svg";

export default function PayrollMappingView() {
	return (
		<PageLayer
			title="Payroll Mappings"
			icon={
				<Stack width={1} direction={"row"} justifyContent={"center"} alignItems={"center"}>
					<SvgIcon viewBox="-2 -2 24 24" className="text-[var(--light-blue-color)] !text-[27px]" component={Icon} />
				</Stack>
			}
		>
			<PayrollMappingLayer />
		</PageLayer>
	);
}
